import { render, staticRenderFns } from "./RoomLeftWaveformPanel.vue?vue&type=template&id=1230f386&scoped=true"
import script from "./RoomLeftWaveformPanel.vue?vue&type=script&lang=js"
export * from "./RoomLeftWaveformPanel.vue?vue&type=script&lang=js"
import style0 from "./RoomLeftWaveformPanel.vue?vue&type=style&index=0&id=1230f386&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1230f386",
  null
  
)

export default component.exports